var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitmentTracking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bar-Chart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.0004 7.50003H16.0004V4.50003C16.0004 3.39703 15.1034 2.50003 14.0004 2.50003H10.0004C8.89744 2.50003 8.00044 3.39703 8.00044 4.50003V9.50003H4.00044C2.89744 9.50003 2.00044 10.397 2.00044 11.5V20.5C2.00044 20.7652 2.1058 21.0196 2.29334 21.2071C2.48087 21.3947 2.73523 21.5 3.00044 21.5H21.0004C21.2657 21.5 21.52 21.3947 21.7076 21.2071C21.8951 21.0196 22.0004 20.7652 22.0004 20.5V9.50003C22.0004 8.39703 21.1034 7.50003 20.0004 7.50003ZM4.00044 11.5H8.00044V19.5H4.00044V11.5ZM10.0004 10.5V4.50003H14.0004V19.5H10.0004V10.5ZM20.0004 19.5H16.0004V9.50003H20.0004V19.5Z",
    fill: "#0D70DC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitmentTracking);
export default __webpack_public_path__ + "static/media/commitment-tracking.4ce76f2750c2578d1d8683f7cb731ee2.svg";
export { ForwardRef as ReactComponent };